import { useState, useCallback } from 'react';
import { apiService } from '../services/api';
import type { NoShowPolicyDto } from '../services/api';
import { getApiErrorMessage } from '../types/api-errors';

export const useNoShowPolicy = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getNoShowPolicy = useCallback(async (): Promise<NoShowPolicyDto> => {
        setLoading(true);
        setError(null);
        try {
            return await apiService.getNoShowPolicy();
        } catch (err: unknown) {
            const msg = getApiErrorMessage(err, 'Unable to load no-show policy.');
            setError(msg);
            throw new Error(msg);
        } finally {
            setLoading(false);
        }
    }, []);

    const updateNoShowPolicy = useCallback(async (data: NoShowPolicyDto): Promise<boolean> => {
        setLoading(true);
        setError(null);
        try {
            return await apiService.updateNoShowPolicy(data);
        } catch (err: unknown) {
            const msg = getApiErrorMessage(err, 'Failed to update no-show policy.');
            setError(msg);
            throw new Error(msg);
        } finally {
            setLoading(false);
        }
    }, []);

    return { loading, error, getNoShowPolicy, updateNoShowPolicy };
};
